<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card>
            <template slot="header">
              <h4 class="card-title">Dati {{objName}}</h4>
              <p class="card-category text-danger" v-if="oggetto.deleted_at">Disattivato</p>
            </template>
            <p v-if="loading" class="card-category">
              <center>Caricamento in corso...</center>
            </p>
            <form v-if="!loading">
              <div class="row">
                <div class="col-md-6 col-xl-3">
                  <fg-input type="text"
                            label="Lavorazione"
                            placeholder="Lavorazione"
                            v-model="oggetto.lavorazione"
                            :disabled="readOnly">
                  </fg-input>
                </div>
                <div class="col-md-6 col-xl-3">
                  <fg-input type="date"
                            label="Data inserimento"
                            v-model="dataInserimento"
                            v-show="dataInserimento"
                            :disabled=true>
                  </fg-input>
                </div>
                <div class="col-md-6 col-xl-3">
                  <fg-input type="date"
                            label="Data eliminazione"
                            v-model="dataEliminazione"
                            v-show="dataEliminazione"
                            :disabled=true>
                  </fg-input>
                </div>
                <div class="col-md-12 text-right">
                  <button type="submit" :disabled="saving" v-if="saving || !readOnly" class="btn btn-info btn-fill" @click.prevent="salva">
                    Salva
                  </button>
                  <button type="submit" :disabled="saving" v-if="!saving && readOnly" class="btn btn-info btn-fill" @click.prevent="modModifica">
                    Modifica
                  </button>
                  <button type="submit" :disabled="saving" v-if="!saving && readOnly && !oggetto.deleted_at" class="btn btn-info btn-fill" @click.prevent="disattiva">
                    Disattiva
                  </button>
                  <button type="submit" :disabled="saving" v-if="!saving && readOnly && oggetto.deleted_at" class="btn btn-info btn-fill" @click.prevent="riattiva">
                    Riattiva
                  </button>
                </div>
              </div>
            </form>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  
  export default {
    components: {
      Card
    },
    data () {
      return {
        objName: 'lavorazione',
        backendPath: 'lavorazione',
        defaultRedirect: '/dashboard/lavorazione-list',
        new: false,
        id: null,
        saving: false,
        loading: true,
        readOnly: true,
        oggetto: {
        }
      }
    },
    computed: {
      dataInserimento: function () {
        if (typeof this.oggetto.created_at === 'string') {
          return this.oggetto.created_at.substr(0, 10)
        }
        return null
      },
      dataEliminazione: function () {
        if (typeof this.oggetto.deleted_at === 'string') {
          return this.oggetto.deleted_at.substr(0, 10)
        }
        return null
      }
    },
    mounted () {
      var me = this
      if (me.$route.meta.new === true) {
        me.$data.new = true
        me.$data.loading = false
        me.$data.readOnly = false
      } else {
        me.$data.id = me.$route.params.id
        me.caricaDati()
      }
    },
    methods: {
      caricaDati: function () {
        var me = this
        var url = process.env.API_URL + me.$data.backendPath + '/' + me.$data.id
        var method = 'GET'
        var params = {withTrashed: true}
        var successFn = function (data) {
          me.$data.loading = false
          me.$data.oggetto = data
        }
        var errorFn = function (message) {
          me.ajaxErrorFn(message)
          me.$root.$router.push(me.$data.defaultRedirect)
        }
        this.ajax(url, method, params, successFn, errorFn)
      },
      modModifica: function () {
        this.$data.readOnly = false
      },
      salva: function () {
        var me = this
        me.$data.readOnly = true
        me.$data.saving = true
        var url
        var method
        if (me.$data.new === true) {
          url = process.env.API_URL + me.$data.backendPath
          method = 'POST'
        } else {
          url = process.env.API_URL + me.$data.backendPath + '/' + me.$data.id + '?withTrashed=true'
          method = 'PUT'
        }
        var params = me.$data.oggetto
        var successFn = function (data) {
          if (me.$data.new === true) {
            me.$data.id = data.id
            me.$data.new = false
          }
          me.$data.oggetto = data
          me.$data.saving = false
          me.$root.$router.push(me.$data.defaultRedirect)
          me.successMessage('Dati ' + me.toUpperFirst(me.$data.objName) + ' salvati')
        }
        var errorFn = function (message) {
          me.$data.readOnly = false
          me.$data.saving = false
          me.ajaxErrorFn(message)
        }
        this.ajax(url, method, params, successFn, errorFn)
      },
      disattiva: function () {
        var me = this
        me.$data.saving = true
        var url = process.env.API_URL + me.$data.backendPath + '/' + me.$data.id
        var method = 'DELETE'
        var params = {}
        var successFn = function (data) {
          me.$data.oggetto = data
          me.$data.saving = false
          // me.$root.$router.push(me.$data.defaultRedirect)
          me.successMessage('Record ' + me.toUpperFirst(me.$data.objName) + ' disattivato')
        }
        var errorFn = function (message) {
          me.$data.saving = false
          me.ajaxErrorFn(message)
        }
        this.ajax(url, method, params, successFn, errorFn)
      },
      riattiva: function () {
        var me = this
        me.$data.saving = true
        var url = process.env.API_URL + me.$data.backendPath + '/' + me.$data.id + '/restore'
        var method = 'PUT'
        var params = {}
        var successFn = function (data) {
          me.$data.oggetto = data
          me.$data.saving = false
          // me.$root.$router.push(me.$data.defaultRedirect)
          me.successMessage('Record ' + me.toUpperFirst(me.$data.objName) + ' riattivato')
        }
        var errorFn = function (message) {
          me.$data.saving = false
          me.ajaxErrorFn(message)
        }
        this.ajax(url, method, params, successFn, errorFn)
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Lavorazione.vue